import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ sidebarOpen, closeSidebar, handleLogout }) => {
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    setLogoUrl(JSON.parse(localStorage.getItem('app_icon')));
  }, []);

  return (
    <div id='sidebar' className={sidebarOpen ? 'sidebar-responsive' : ''}>
      <div className='sidebar_title'>
        <div className='sidebar_img'>
          <img src={`https://stucharge.bakersbrisk.com${logoUrl}`} alt='logo' />
          <h1>Admin Panel</h1>
        </div>
        <i className='fa fa-times' id='sidebaricon' onClick={closeSidebar}></i>
      </div>
      <div className='sidebar_menu'>
        <div className='sidebar_link'>
          <NavLink to='/home' activeClassName='active_menu_link'>
            <i className='fa fa-home'></i>Dashboard
          </NavLink>
        </div>
        <h2>MNG</h2>

        <div className='sidebar_link'>
          <NavLink to='/profile' activeClassName='active_menu_link'>
            <i className='fas fa-user-circle'></i>Profile{' '}
          </NavLink>
        </div>
        <div className='sidebar_link'>
          <NavLink to='/subjects' activeClassName='active_menu_link'>
            <i className='fas fa-book'></i>Subjects{' '}
          </NavLink>
        </div>
        <div className='sidebar_link'>
          <NavLink to='/courses' activeClassName='active_menu_link'>
            <i className='fa fa-graduation-cap'></i>Courses
          </NavLink>
        </div>
        <div className='sidebar_link'>
          <NavLink to='/notes' activeClassName='active_menu_link'>
            <i className='fas fa-book-open'></i> Notes
          </NavLink>
        </div>
        <div className='sidebar_link'>
          <NavLink to='/class' activeClassName='active_menu_link'>
            <i className='fas fa-chalkboard-teacher'></i>Online Class
          </NavLink>
        </div>
        <div className='sidebar_link'>
          <NavLink to='/contact' activeClassName='active_menu_link'>
            <i className='fa fa-handshake-o'></i>Contact Dev
          </NavLink>
        </div>
        <h2>LEAVE</h2>
        <div className='sidebar_logout'>
          <i className='fa fa-power-off'></i>
          <NavLink to='/' onClick={handleLogout}>
            Log out
          </NavLink>
        </div>
        <div
          className='dev'
          style={{ position: 'absolute', bottom: '60px', left: '8px' }}
        >
          <h3 style={{ color: '#51c4d3' }}>
            Developed by{' '}
            <i
              className='far fa-thumbs-up'
              style={{ fontSize: '1.4rem', marginLeft: '4px' }}
            ></i>
          </h3>
          <h2 style={{ color: '#b0efeb' }}>Codeven Solution</h2>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
